import axios from "axios"
import { useState } from "react"

export default function PopForm ({close, product}){
    const [talk, setTalk] = useState({
        name:'',
        mobile:'',
        mail:'',
        state:'',
        pincode:'',
        want:'',
        write:''
    })
    const fieldChange = (e) =>{
        const {name, value} = e.target
        setTalk((preData)=>({
            ...preData,
            [name]:value
        }))
    }
    const [submitAvai, setSubmitAvai] = useState(false)
    const talkSubmit = (e) =>{
        e.preventDefault()
        setSubmitAvai(true)
        try{
            const formData = new FormData();
            formData.append('name',talk.name);
            formData.append('mobile',talk.mobile);
            formData.append('mail',talk.mail);
            formData.append('state',talk.state);
            formData.append('pincode',talk.pincode);
            formData.append('want',talk.want);
            formData.append('write',talk.write);
            product && formData.append('product',`${product}`);

            axios.post(`${process.env.React_APP_API_URL}/api/v1/general/mail`, formData)
            .then(res=>{
                setTalk({
                    name:'',
                    mobile:'',
                    mail:'',
                    state:'',
                    pincode:'',
                    want:'',
                    write:'',
                })
                setSubmitAvai(false)
                alert("Our Team will Contact You Soon...")
            })
        }catch(err){
            setSubmitAvai(false)
            console.error('Error:',err);
        }
    }
    return(
        <div className='popContainer'>
            <div className='popMain'>
                <div className='popImage'>
                    <img src='../images/popImage.png'/>
                </div>
                <div className='popFormContainer'>
                    <form className='popForm' onSubmit={talkSubmit}>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Name</label>
                            <input 
                                className='popInput' 
                                type='text'
                                name='name'
                                value={talk.name}
                                onChange={fieldChange}
                                required
                            />
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Mobile Number</label>
                            <input 
                                className='popInput' 
                                type='text'
                                name='mobile'
                                value={talk.mobile}
                                onChange={fieldChange}
                                required
                            />
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Mail ID</label>
                            <input 
                                className='popInput' 
                                type='text'
                                name='mail'
                                value={talk.mail}
                                onChange={fieldChange}
                            />
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Region</label>
                            <select 
                            className='popInput'
                            name='state'
                            value={talk.state}
                            onChange={fieldChange}
                            required>
                                <option hidden>------------</option>
                                <option value='Tamilnadu'>Tamilnadu</option>
                                <option value='Kerala'>Kerala</option>
                                <option value='Karnataka'>Karnataka</option>
                                <option value='AP'>AP</option>
                            </select>
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Pincode</label>
                            <input 
                                className='popInput' 
                                type='number'
                                name='pincode'
                                value={talk.pincode}
                                onChange={fieldChange}
                                required
                            />
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"40%"}}>
                            <label>Look for</label>
                            <select 
                                className='popInput'
                                name='want'
                                value={talk.want}
                                onChange={fieldChange}
                                required>
                                <option hidden>------------</option>
                                <option value='Solar Water Heater' >Solar Water Heater</option>
                                <option value='Solar Water Pump' >Solar Water Pump</option>
                                <option value='Solar Street Light' >Solar Street Light</option>
                                <option value='UPS & Battery' >UPS & Battery</option>
                            </select>
                        </div>
                        <div className='inputContainer popInputContainer' style={{width:"92%"}}>
                            <label>Write Us</label>
                            <textarea 
                                className='popInput'
                                name='write'
                                value={talk.write}
                                onChange={fieldChange}
                                required
                            />
                        </div>
                        <div className='inputContainer popInputContainer submitContainer'>
                            <input 
                                type='submit' 
                                className='popSubmit' 
                                value={submitAvai?'Sending...':"Submit"}
                                disabled={submitAvai}
                                style={{cursor:"pointer"}}
                            />
                        </div>
                    </form>
                    <div className='popFooter'>
                        <div className='popCol'>
                            <p>lets Start your</p>
                            <h2>Green Journey</h2>
                            <p>Today</p>
                        </div>
                        
                    </div>
                    <div className='popLogo'>
                        <img src='../images/footerLogo.png'/>
                    </div>
                </div>
                <div className='popClose' onClick={()=>close()}>
                    <h4>X</h4>
                </div>
            </div>
        </div>
    )
}